import { Timestamp } from 'firebase/firestore'
import { Dispatch, SetStateAction } from 'react'

export interface Skill {
  id?: string
  name?: string
  description?: string
  createdAt?: Timestamp
  lastUpdated?: Timestamp
  lowercaseName?: string
  parentId?: string
  users?: number
  category?: string
}

// Context Props
export interface SkillsContextProps {
  allSkills: Skill[]
  setAllSkills: Dispatch<SetStateAction<Skill[]>>
  ourSkills: Skill[]
  setOurSkills: Dispatch<SetStateAction<Skill[]>>
  // Future fields (not currently used in context but may be needed)
  fetchSkill?: () => Promise<void>
  createSkill?: (skillName: string, description: string) => Promise<void>
  deleteSkill?: (id: string) => Promise<void>
  skills?: Skill[]
  setSkills?: Dispatch<SetStateAction<Skill[]>>
}

export const SkillsContextDefaultValues: SkillsContextProps = {
  allSkills: [],
  setAllSkills: () => {},
  ourSkills: [],
  setOurSkills: () => {},
}
